import { createContext, useEffect, useState } from "react";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged
} from 'firebase/auth'
import { auth, firebase, storage, provider, signInWithPopup } from '../Firebase'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, collection, addDoc, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { useContext } from "react";
import axios from "axios";
import { UrlApi } from "../Keys";
import {
    toast
} from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { authMail, authPass } from "../Keys";

const UserContext = createContext()

export const AuthContextProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState({})
    const [loading, setLoading] = useState(false); //loader del login
    const [loadingRegistro, setLoadingRegistro] = useState(false); //loader del registro

    const [empleado, setEmpleado] = useState({
        idEmpleado: '',
        usuarioPortalRh: '',
        photoURL: '',
        photoPORTADA: '',
        puesto: '',
        habilitadoNovedad: '',
        habilitadoOrganigrama: ''
    }) //estos son los datos que vamos a completar en un login o en un registro para luego usarlos en llamadas a los fetch

    //los 2 useEffect de abajo son para almacenar esos campos. Para el hipotetico caso de que se refresque la pagina nunca se pierdan esos datos.
    useEffect(() => {
        // debugger
        // Intentar obtener el estado del empleado del localStorage al cargar el contexto
        const storedEmpleado = localStorage.getItem('empleado');
        if (storedEmpleado) {
            setEmpleado(JSON.parse(storedEmpleado));
        }
    }, []);

    useEffect(() => {
        // debugger
        // Actualizar el localStorage cuando el estado del empleado cambie
        localStorage.setItem('empleado', JSON.stringify(empleado));
    }, [empleado]);

    //verifica constantemente el estado de la sesion activa

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser)
        })
        return () => {
            unsubscribe()
        }
    }, [])

    const createUser = async (data, token) => {
        setLoadingRegistro(true);
        const { correo, password, opcion } = data;

        var entidad = 'new_empleados';
        var fetch =
            "<entity name='new_empleado'>" +
            "<attribute name='new_name'/>" +
            "<attribute name='new_cuitcuil'/>" +
            "<attribute name='new_correoelectronico'/>" +
            "<attribute name='new_numerolegajo'/>" +
            "<attribute name='new_empleadoid'/>" +
            "<attribute name='new_usuarioportalrh'/>" +
            "<attribute name='new_roldocente'/>" +
            "<attribute name='new_puesto'/>" +
            "<order attribute='new_numerolegajo' descending='false'/>" +
            "<filter type='and'>" +
            "<condition attribute='new_usuarioportalrh' operator='eq' value='" + correo + "'/>" +
            "</filter>" +
            "</entity>";
        var empleadoid = ''
        var usuarioPortalRh = ''
        var puesto = ''
        try {
            debugger
            const respMail = await axios.post(`${UrlApi}api/consultafetch`,
                {
                    "entidad": entidad,
                    "fetch": fetch
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });
            if (respMail.data.length === 0) {
                throw new Error('No existe una cuenta con ese correo en nuestro sistema');
            }
            empleadoid = respMail.data[0].new_empleadoid
            usuarioPortalRh = respMail.data[0].new_usuarioportalrh
            puesto = respMail.data[0].new_roldocente ? 'docente' : 'codocente'
            setEmpleado({
                empleadoid: empleadoid,
                usuarioPortalRh: usuarioPortalRh,
                puesto: puesto

            });

            // Crear la cuenta de usuario con correo electrónico y contraseña
            const userCredential = await createUserWithEmailAndPassword(auth, correo, password);

            setLoadingRegistro(false);
            // Obtener el UID del usuario recién creado
            const uid = userCredential.user.uid;

            // Guardar los datos del usuario en la base de datos
            await firebase.collection('usuarios').add({
                puesto: opcion,
                empleadoid: empleadoid,
                uid,
                correoElectronico: correo,
                usuarioPortalRh: usuarioPortalRh
            });
        } catch (error) {
            console.log("error firebase:", error)
            setLoadingRegistro(false);
            // Manejar errores de creación de cuenta
            if (error.code === "auth/account-exists-with-different-credential") {
                throw new Error("La cuenta ya existe con diferentes credenciales!");
            } else if (error.code === "auth/email-already-in-use") {
                throw new Error("El correo ya está en uso!");
            } else if (error.code === "auth/credential-already-in-use") {
                throw new Error("Las credenciales están en uso!");
            } else {
                throw error;
            }
        }
    };
    //manejo del login
    const signIn = (email, password) => {
        setLoading(true);

        return signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Manejar el resultado de inicio de sesión exitoso
                const user = userCredential.user;
                console.log('respuesta dynamics', user);
                // Inicializo el token
                let respEmpleado;
                let token = '';

                const verificacion = () =>
                    new Promise(async (resolve, reject) => {
                        // Obtengo el token
                        try {
                            const resp = await axios.post(`${UrlApi}api/Usuarios/login`, {
                                email: authMail,
                                password: authPass,
                            });
                            token = resp.data;

                            // Realizo la consulta a la API
                            const entidad = 'new_empleados';
                            const fetch =
                                "<entity name='new_empleado'>" +
                                "<attribute name='new_name'/>" +
                                "<attribute name='new_cuitcuil'/>" +
                                "<attribute name='new_correoelectronico'/>" +
                                "<attribute name='new_numerolegajo'/>" +
                                "<attribute name='new_empleadoid'/>" +
                                "<attribute name='new_usuarioportalrh'/>" +
                                "<attribute name='new_roldocente'/>" +
                                "<attribute name='new_puesto'/>" +
                                "<attribute name='new_habilitadocargadenovedadesdepago'/>" +
                                "<attribute name='new_tieneaccesonuevoportalcodocente'/>" +
                                "<attribute name='new_habilitadoparaorganigrama'/>" +
                                "<order attribute='new_numerolegajo' descending='false'/>" +
                                "<filter type='and'>" +
                                "<condition attribute='new_correoelectronico' operator='eq' value='" +
                                user.email +
                                "'/>" +
                                "<condition attribute='new_tieneaccesonuevoportalcodocente' operator='eq' value='true' />" +
                                "</filter>" +
                                "</entity>";

                            const respMail = await axios.post(
                                `${UrlApi}api/consultafetch`,
                                {
                                    entidad: entidad,
                                    fetch: fetch,
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${token.token}`,
                                    },
                                }
                            );
                            if (respMail.data.length === 0) {
                                reject('No existe una cuenta con ese correo en nuestro sistema');
                                navigate('/acceso-denegado');
                                // Desautenticar al usuario
                                signOut(auth).then(() => {
                                    console.log('Usuario desautenticado');
                                }).catch((signOutError) => {
                                    console.error('Error al desautenticar:', signOutError);
                                });
                            } else {
                                respEmpleado = respMail.data[0];
                                const userRef = firebase.collection('usuarios').doc(user.uid);
                                const doc = await userRef.get();
                                // debugger
                                if (!doc.exists || !doc.data().uid) {
                                    // El usuario no tiene un registro en Firestore, crear uno
                                    const userData = {
                                        // Datos del usuario que deseas guardar en Firestore
                                        nombre: respEmpleado.new_name,
                                        cuit: respEmpleado.new_cuitcuil,
                                        empleadoid: respEmpleado.new_empleadoid,
                                        correoElectronico: user.email,
                                        usuarioPortalRh: user.email,
                                        puesto: user.email.endsWith('@ues21.edu.ar') ? 'codocente' : 'docente',
                                        uid: user.uid
                                        // ...
                                    };

                                    await userRef.set(userData, { merge: true });

                                    setEmpleado({
                                        empleadoid: respEmpleado.new_empleadoid,
                                        usuarioPortalRh: user.email,
                                        puesto: user.email.endsWith('@ues21.edu.ar') ? 'codocente' : 'docente',
                                        habilitadoNovedad: respEmpleado.new_habilitadocargadenovedadesdepago,
                                        habilitadoOrganigrama: respEmpleado.new_habilitadoparaorganigrama,
                                        uid: user.uid
                                    });
                                } else {

                                    setEmpleado({
                                        empleadoid: respEmpleado.new_empleadoid,
                                        usuarioPortalRh: user.email,
                                        photoURL: doc.data().photoURL,
                                        photoPORTADA: doc.data().photoPORTADA,
                                        puesto: user.email.endsWith('@ues21.edu.ar') ? 'codocente' : 'codocente',
                                        habilitadoNovedad: respEmpleado.new_habilitadocargadenovedadesdepago,
                                        habilitadoOrganigrama: respEmpleado.new_habilitadoparaorganigrama,
                                        uid: user.uid
                                    });
                                }

                                // Redirigir al usuario al inicio después de crear el registro o si ya existe
                                resolve('/inicio');
                            }
                        } catch (error) {
                            console.log(error)
                            reject(
                                'Hubo un error al iniciar sesión, por favor intente más tarde'
                            );
                        }
                    });

                // Invocar la función de verificación y manejar el resultado
                toast.promise(
                    verificacion(),
                    {
                        pending: 'Autenticando...',
                        error: {
                            render({ data }) {
                                return `${data}`;
                            },
                        },
                    },
                    {
                        theme: 'dark',
                        position: 'top-center',
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    }
                )
                .then((redirectPath) => {
                    navigate(redirectPath);
                })
                .catch((error) => {
                    console.log(error);
                });
            })
            .catch((error) => {
                if (error.code === 'auth/account-exists-with-different-credential') {
                    const email = error.email;
                    // Mostrar una página de selección para que el usuario elija cómo iniciar sesión
                    toast.error('Ya existe una cuenta con diferentes credenciales. Si te registraste con correo y contraseña, debes usar ese metodo.', {
                        theme: "dark",
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // navigate('/seleccionar-metodo-inicio-sesion', { email });
                } else {
                    // Otro tipo de error de inicio de sesión
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log('Error de inicio de sesión', errorCode, errorMessage);
                }
            });
    };

    //manejo del login
    const signInAdmin = (email, password) => {
        setLoading(true);

        return signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                setLoading(false);
                const uid = userCredential.user.uid;

                console.log('Usuario UID:', uid);

                // Obtener el documento del usuario desde Firestore
                firebase
                    .collection('usuarios')
                    .where('uid', '==', uid)
                    .get()
                    .then((querySnapshot) => {
                        console.log('QuerySnapshot:', querySnapshot);

                        if (!querySnapshot.empty) {
                            const userData = querySnapshot.docs[0].data();
                            console.log('Datos del usuario:', userData);

                            setEmpleado({
                                empleadoid: userData.empleadoid,
                                usuarioPortalRh: userData.usuarioPortalRh,
                                photoURL: userData.photoURL,
                                photoPORTADA: userData.photoPORTADA,
                                puesto: userData.puesto,
                                uid: userData.uid,
                                habilitadoNovedad: userData.habilitadoNovedad
                            });
                        }
                    })
                    .catch((error) => {
                        console.log('Error al obtener el documento del usuario:', error);
                    });
            })
            .catch((error) => {
                setLoading(false);
                throw error;
            });
    };


    // const signInWithCustomOIDC2 = () => {
    //   const authorizeUrl = 'https://ecampus.uesiglo21.edu.ar/menu/api/oauth2/authorize';
    //   const clientId = '517747872895899';
      
  
    //   // const redirectUri = 'https://portal-gestion-academica-uat.firebaseapp.com/__/auth/handler';  // Debe coincidir con la URL de redirección registrada
    //   // const redirectUri = 'http://localhost:3000/__/auth/handler';  // Debe coincidir con la URL de redirección registrada
    //   const redirectUri = 'http://localhost:3000/login-docente';  // Debe coincidir con la URL de redirección registrada
    //   const responseType = 'code'; // Tipo de respuesta que se espera
    
    //   // Construir la URL de autorización
    //   const authUrl = `${authorizeUrl}?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}`;
    
    //   // Redirigir al usuario para obtener el código de autorización
    //   window.location.href = authUrl;
  
  
    // };
    
    const signInWithMicrosoft = () => {
        signInWithPopup(auth, provider)
            .then((result) => {
                // Manejar el resultado de inicio de sesión exitoso
                const user = result.user;
                console.log('respuesta dynamics', user);
                // Inicializo el token
                let respEmpleado;
                let token = '';

                const verificacion = () =>
                    new Promise(async (resolve, reject) => {
                        // Obtengo el token
                        try {
                            const resp = await axios.post(`${UrlApi}api/Usuarios/login`, {
                                email: authMail,
                                password: authPass,
                            });
                            token = resp.data;
                            // debugger
                            // Realizo la consulta a la API
                            const entidad = 'new_empleados';
                            const fetch =
                                "<entity name='new_empleado'>" +
                                "<attribute name='new_name'/>" +
                                "<attribute name='new_cuitcuil'/>" +
                                "<attribute name='new_correoelectronico'/>" +
                                "<attribute name='new_numerolegajo'/>" +
                                "<attribute name='new_empleadoid'/>" +
                                "<attribute name='new_usuarioportalrh'/>" +
                                "<attribute name='new_roldocente'/>" +
                                "<attribute name='new_puesto'/>" +
                                "<attribute name='new_habilitadocargadenovedadesdepago'/>" +
                                "<attribute name='new_tieneaccesonuevoportalcodocente'/>" +
                                "<attribute name='new_habilitadoparaorganigrama'/>" +
                                "<order attribute='new_numerolegajo' descending='false'/>" +
                                "<filter type='and'>" +
                                "<condition attribute='new_correoelectronico' operator='eq' value='" +
                                user.email +
                                "'/>" +
                                "<condition attribute='new_tieneaccesonuevoportalcodocente' operator='eq' value='true' />" +
                                "</filter>" +
                                "</entity>";

                            const respMail = await axios.post(
                                `${UrlApi}api/consultafetch`,
                                {
                                    entidad: entidad,
                                    fetch: fetch,
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${token.token}`,
                                    },
                                }
                            );
                            if (respMail.data.length === 0) {
                                reject('No existe una cuenta con ese correo en nuestro sistema');
                                navigate('/acceso-denegado');
                                // Desautenticar al usuario
                                signOut(auth).then(() => {
                                    console.log('Usuario desautenticado');
                                }).catch((signOutError) => {
                                    console.error('Error al desautenticar:', signOutError);
                                });
                            } else {
                                respEmpleado = respMail.data[0];
                                const userRef = firebase.collection('usuarios').doc(user.uid);
                                const doc = await userRef.get();
                                // debugger
                                if (!doc.exists || !doc.data().uid) {
                                    // El usuario no tiene un registro en Firestore, crear uno
                                    const userData = {
                                        // Datos del usuario que deseas guardar en Firestore
                                        nombre: respEmpleado.new_name,
                                        cuit: respEmpleado.new_cuitcuil,
                                        empleadoid: respEmpleado.new_empleadoid,
                                        correoElectronico: user.email,
                                        usuarioPortalRh: user.email,
                                        puesto: user.email.endsWith('@ues21.edu.ar') ? 'codocente' : 'docente',
                                        uid: user.uid
                                        // ...
                                    };

                                    await userRef.set(userData, { merge: true });

                                    setEmpleado({
                                        empleadoid: respEmpleado.new_empleadoid,
                                        usuarioPortalRh: user.email,
                                        puesto: user.email.endsWith('@ues21.edu.ar') ? 'codocente' : 'docente',
                                        habilitadoNovedad: respEmpleado.new_habilitadocargadenovedadesdepago,
                                        habilitadoOrganigrama: respEmpleado.new_habilitadoparaorganigrama,
                                        uid: user.uid
                                    });
                                } else {

                                    setEmpleado({
                                        empleadoid: respEmpleado.new_empleadoid,
                                        usuarioPortalRh: user.email,
                                        photoURL: doc.data().photoURL,
                                        photoPORTADA: doc.data().photoPORTADA,
                                        puesto: user.email.endsWith('@ues21.edu.ar') ? 'codocente' : 'docente',
                                        habilitadoNovedad: respEmpleado.new_habilitadocargadenovedadesdepago,
                                        habilitadoOrganigrama: respEmpleado.new_habilitadoparaorganigrama,
                                        uid: user.uid
                                    });
                                }

                                // Redirigir al usuario al inicio después de crear el registro o si ya existe
                                resolve('/inicio');
                            }
                        } catch (error) {
                            console.log(error)
                            reject(
                                'Hubo un error al iniciar sesión, por favor intente más tarde'
                            );
                        }
                    });

                // Invocar la función de verificación y manejar el resultado
                toast.promise(
                    verificacion(),
                    {
                        pending: 'Autenticando...',
                        error: {
                            render({ data }) {
                                return `${data}`;
                            },
                        },
                    },
                    {
                        theme: 'dark',
                        position: 'top-center',
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    }
                )
                    .then((redirectPath) => {
                        navigate(redirectPath);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                if (error.code === 'auth/account-exists-with-different-credential') {
                    const email = error.email;
                    // Mostrar una página de selección para que el usuario elija cómo iniciar sesión
                    toast.error('Ya existe una cuenta con diferentes credenciales. Si te registraste con correo y contraseña, debes usar ese metodo.', {
                        theme: "dark",
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    // navigate('/seleccionar-metodo-inicio-sesion', { email });
                } else {
                    // Otro tipo de error de inicio de sesión
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log('Error de inicio de sesión', errorCode, errorMessage);
                }
            });
    };


    const actualizarFotoPerfil = async (imgEditada) => {
        //uid

        const user = auth.currentUser;
        // Referencia a Storage
        const storageRef = ref(storage, `${user.uid}/foto perfil`);
        const toastLoading = toast.info('Cargando foto...', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        });
        await uploadBytes(storageRef, imgEditada)

        // Obtener la URL directa de la imagen
        const imgURL = await getDownloadURL(storageRef);

        // Asegúrate de que user.uid tenga un valor definido
        if (user.uid) {
            // Referencia a Firestore
            const usuariosRef = collection(firebase, 'usuarios');
            const userQuery = query(usuariosRef, where('uid', '==', user.uid));
            const querySnapshot = await getDocs(userQuery);

            if (querySnapshot.docs.length > 0) {
                const userDoc = querySnapshot.docs[0];
                const userRef = doc(usuariosRef, userDoc.id);

                // Actualizar la propiedad 'photoPORTADA' en Firestore
                await updateDoc(userRef, { photoURL: imgURL });

                // Actualizar solo la propiedad photoPORTADA en el estado del componente
                setEmpleado((prevEmpleado) => ({
                    ...prevEmpleado,
                    photoURL: imgURL,
                }));

                toast.dismiss(toastLoading);
                toast.success('Tu foto se ha cargado correctamente.', {
                    theme: "dark",
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("Usuario no encontrado.", {
                    theme: "dark",
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            toast.error("UID de usuario no definido.", {
                theme: "dark",
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const actualizarFotoPortada = async (imgEditada) => {
        //uid

        const user = auth.currentUser;
        // Referencia a Storage
        const storageRef = ref(storage, `${user.uid}/foto portada`);
        const toastLoading = toast.info('Cargando foto...', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        });
        await uploadBytes(storageRef, imgEditada)

        // Obtener la URL directa de la imagen
        const imgURL = await getDownloadURL(storageRef);

        // Asegúrate de que user.uid tenga un valor definido
        if (user.uid) {
            // Referencia a Firestore
            const usuariosRef = collection(firebase, 'usuarios');
            const userQuery = query(usuariosRef, where('uid', '==', user.uid));
            const querySnapshot = await getDocs(userQuery);

            if (querySnapshot.docs.length > 0) {
                const userDoc = querySnapshot.docs[0];
                const userRef = doc(usuariosRef, userDoc.id);

                // Actualizar la propiedad 'photoPORTADA' en Firestore
                await updateDoc(userRef, { photoPORTADA: imgURL });

                // Actualizar solo la propiedad photoPORTADA en el estado del componente
                setEmpleado((prevEmpleado) => ({
                    ...prevEmpleado,
                    photoPORTADA: imgURL,
                }));

                toast.dismiss(toastLoading);
                toast.success('Tu foto se ha cargado correctamente.', {
                    theme: "dark",
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("Usuario no encontrado.", {
                    theme: "dark",
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            toast.error("UID de usuario no definido.", {
                theme: "dark",
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const logout = async () => {
        try {
            // Limpiar el localStorage
            localStorage.clear();
            setEmpleado({});
            // Cerrar sesión
            await signOut(auth);

            // Redirigir o realizar otras acciones después del cierre de sesión
            // ...
        } catch (error) {
            // Manejar errores
            console.error('Error al cerrar sesión:', error);
        }
    };

    return (
        <UserContext.Provider value={{ createUser, user, logout, signIn, signInAdmin, loading, signInWithMicrosoft, loadingRegistro, empleado, actualizarFotoPerfil, actualizarFotoPortada }}>
            {children}
        </UserContext.Provider>
    )
}

export const UserAuth = () => {
    return useContext(UserContext)
}